import React, { Component, Fragment } from 'react';
import SashiDo from 'lib/SashiDo';
import { Decimal } from 'decimal.js';
import Tooltip from 'react-autotip';
import Icon from 'components/Icon/Icon.react';
import Label from 'components/Label/Label.react';
import LinkWithBack from 'components/LinkWithBack/LinkWithBack.react';

import { bytesToSize, numeral } from 'lib/helpers';
import stylesButton from 'components/Button/Button.scss';
import Button from 'components/Button/Button.react';
import stylesLoader from 'components/CloudCodeStatus/CloudCodeStatus.scss';
import Toggle from 'components/Toggle/Toggle.react';
import Notification from 'components/Notification/Notification.react';
import Field from 'components/Field/Field.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import settingsStyles from 'dashboard/Settings/Settings.scss';
import ProgressPie from './components/ProgressPie.react';
import styles from './EngineView.scss';


class Form extends Component {
  constructor(props) {
    super(props);

    this.state = {
      note: null,
      showSave: false,
    };

    this.currentPlanFromAPI = 1;
    this.currentBillingPolicyFromAPI = 'hourly';
  }

  async componentDidMount() {
    const { currentApp } = this.props;


    const { id: appId } = currentApp;
    const { fields } = await currentApp.fetchSettingsFields();

    const { engine, engine_scaling_config, highly_available } = fields;
    const engineScalingConfig = engine_scaling_config;

    const region = Object.keys(engine)[0];

    let productsData;
    try {
      productsData = await SashiDo.getProducts();
    } catch (e) {
      // console.log('Error:', e);
    }

    const gearTypes = {
      hourly: [],
      monthly: [],
    };

    productsData.forEach((item) => {
      const {
        cpu,
        ram,
        toolTipText,
      } = item.params;

      gearTypes[item.billingPolicy].push({
        allowedInTrial: item.allowedInTrial,
        name: item.name,
        price: item.price,
        toolTipText,
        ram,
        cpu,
        extras: item.extras,
      });
    });

    const { name } = engine[region];

    let currentPlan = 0;
    let currentPlanPrice = 0;

    gearTypes.hourly.forEach((item, i) => {
      if (item.name === name) {
        currentPlan = i;
        currentPlanPrice = item.price;
      }
    });

    const containerCurrentDeployment = await SashiDo.containerCurrentDeployment({ appId });
    const { min, max, auto } = containerCurrentDeployment.deployment.replicas;

    this.currentPlanFromAPI = currentPlan;
    this.currentBillingPolicyFromAPI = 'hourly';

    let scalingType = 'fixed';
    let buffer = engineScalingConfig.buffer;
    if (buffer >= 0) {
      scalingType = 'dynamic';
      buffer = engineScalingConfig.buffer;
    }

    this.setState({
      engineScalingConfig,
      scalingType,
      currentSetup: {
        min,
        max,
        buffer,
        autoscaling: auto,
        highAvailability: !!highly_available,
      },
      originalSetup: {
        min,
        max,
        autoscaling: auto,
        highAvailability: !!highly_available,
        name,
        buffer,
        price: currentPlanPrice,
      },
      currentPlan,
      billingPolicy: 'hourly',
      gearTypes,
      region,
      note: null,
    }, () => {
      this.props.onLoadComplete();
    });
  }

  onModifiedFields() {
    setTimeout(() => {
      const {
        currentSetup,
        currentPlan,
        billingPolicy,
        originalSetup,
      } = this.state;

      if (
        originalSetup.autoscaling !== currentSetup.autoscaling ||
        originalSetup.highAvailability !== currentSetup.highAvailability ||
        originalSetup.min !== currentSetup.min ||
        originalSetup.max !== currentSetup.max ||
        currentPlan !== this.currentPlanFromAPI ||
        billingPolicy !== this.currentBillingPolicyFromAPI
      ) {
        this.props.toggleFooter();
      } else {
        this.props.toggleFooter(true);
      }
    }, 400);
  }

  onScale = (options) => {
    this.setState({
      showSave: true,
      currentSetup: {
        ...this.state.currentSetup,
        min: options.newMin,
        max: options.newMax,
      },
      note: null,
    });

    this.onModifiedFields();
  }

  handlePlanClick = (currentPlan) => {
    this.setState({ currentPlan, showSave: true, note: null });
    this.onModifiedFields();
  }

  handleAutoscaling = () => {
    this.setState((prevState) => {
      let newMin = prevState.currentSetup.min;
      let newMax = prevState.currentSetup.max;

      if (prevState.currentSetup.autoscaling) {
        newMax = newMin;
      } else {
        newMax = newMin + prevState.currentSetup.buffer;

        if (prevState.engineScalingConfig.buffer < 0) {
          newMax = prevState.engineScalingConfig.max;
        }

        if (newMax > prevState.engineScalingConfig.max) {
          newMin = prevState.engineScalingConfig.min;
        }
      }

      if (newMax > prevState.engineScalingConfig.max) {
        newMax = prevState.engineScalingConfig.max;
      }


      return {
        showSave: true,
        note: null,
        currentSetup: {
          ...prevState.currentSetup,
          min: newMin,
          max: newMax,
          autoscaling: !prevState.currentSetup.autoscaling,
        },
      };
    }, () => {
      this.onModifiedFields();
    });
  }

  handleSave = () => {
    this.setState({
      deploing: true,
      showSave: false,
      note: null,
    }, async () => {
      const {
        currentSetup,
        gearTypes,
        billingPolicy,
        currentPlan,
        region,
      } = this.state;

      const { appId } = this.props;

      try {
        await SashiDo.highAvailability({
          appId,
          options: {
            enabled: currentSetup.highAvailability,
          },
        });
      } catch (e) {
        // console.log('Error', e.response)
      }

      try {
        await SashiDo.containerScale({
          appId,
          options: {
            min: currentSetup.min,
            max: currentSetup.max,
            auto: currentSetup.autoscaling,
          },
        });
      } catch (e) {
        // console.log('Error', e.response)
      }

      try {
        await SashiDo.setEngine({
          appId,
          options: {
            region,
            name: gearTypes[billingPolicy][currentPlan].name,
            billingPolicy,
          },
        });
      } catch (e) {
        // console.log('Error', e.response)
      }

      this.currentPlanFromAPI = currentPlan;
      this.currentBillingPolicyFromAPI = billingPolicy;

      const { name, price } = this.state.gearTypes.hourly[currentPlan];

      this.setState({
        originalSetup: {
          min: currentSetup.min,
          max: currentSetup.max,
          name,
          price,
          autoscaling: currentSetup.autoscaling,
          highAvailability: currentSetup.highAvailability,
          note: null,
        },
        deploing: false,
      }, () => {
        this.onModifiedFields();
      });
    });
  }

  handleHA = () => {
    this.setState((prevState) => {
      let newMin = prevState.currentSetup.min;
      let newMax = prevState.currentSetup.max;
      let { autoscaling } = prevState.currentSetup;
      const { buffer } = prevState.currentSetup;

      if (!prevState.currentSetup.highAvailability) {
        autoscaling = true;
        if (prevState.currentSetup.min <= 3) {
          newMin = 3;
          newMax = 3 + buffer;

          if (buffer < 0) {
            newMax = prevState.engineScalingConfig.max;
          }
        } else {
          newMin = prevState.currentSetup.min;
          newMax = prevState.currentSetup.min + prevState.currentSetup.buffer;

          if (buffer < 0) {
            newMax = prevState.engineScalingConfig.max;
          }
        }
      }

      if (newMax > prevState.engineScalingConfig.max) {
        newMax = prevState.engineScalingConfig.max;
      }

      return {
        showSave: true,
        note: null,
        currentSetup: {
          ...prevState.currentSetup,
          min: newMin,
          max: newMax,
          autoscaling,
          highAvailability: !prevState.currentSetup.highAvailability,
        },
      };
    }, () => {
      this.onModifiedFields();
    });
  }

  renderPlans = (type) => {
    const {
      currentPlan,
      gearTypes,
    } = this.state;

    const isTrial = this.props.currentCustomer.is_trial;

    const results = gearTypes[type].map((item, i) => {
      const classnames = [styles.row, currentPlan === i ? styles.active : ''];
      const p = new Decimal(item.price).toFixed(3).toString().split('.');


      const disableInTrial = isTrial && !item.allowedInTrial;

      if (disableInTrial) {
        classnames.push(styles.disableInTrial);

        return (
          <div
            key={item.name}
            className={classnames.join(' ')} >
            <div className={[styles.cell, styles.name].join(' ')}>
              <span>{item.name}</span>
              <span className={styles.notAvailable}>Not available in Trial</span>
              {
                item.toolTipText &&
                <Tooltip
                  text={item.toolTipText}
                  tooltipStyles={{
                    color: '#fff',
                    fontFamily: 'Ubuntu',
                    fontSize: 14,
                    fontWeigt: 300,
                    borderRadius: 4,
                    maxWidth: 300,
                    width: 200,
                    unit: 4,
                    lightgrey: '#222933',
                    opaqueGrey: '#222933',
                  }}>
                  <Icon name="icon-info" width={16} height={16} fill="#47689f" />
                </Tooltip>
              }
            </div>
            <div className={styles.cell}>
              {item.cpu}
            </div>
            <div className={styles.cell}>
              {bytesToSize(item.ram)}
            </div>
            <div className={styles.cell}>
              {
                item.extras.requests > 0
                  ? <div className={styles.upTo}><span>up to</span>{numeral(item.extras.requests, '0a')}</div>
                  : '-'
              }
            </div>
            <div className={styles.cell}>
              <div className={styles.price}>
                <div><em>$</em>{p[0]}<span>.{p[1]}</span></div>
              </div>
            </div>
          </div>
        );
      }


      return (
        <div
          key={item.name}
          className={classnames.join(' ')}
          onClick={() => this.handlePlanClick(i)} >
          <div className={[styles.cell, styles.name].join(' ')}>
            {item.name}
            {
              item.toolTipText &&
              <Tooltip
                text={item.toolTipText}
                tooltipStyles={{
                  color: '#fff',
                  fontFamily: 'Ubuntu',
                  fontSize: 14,
                  fontWeigt: 300,
                  borderRadius: 4,
                  maxWidth: 300,
                  width: 200,
                  unit: 4,
                  lightgrey: '#222933',
                  opaqueGrey: '#222933',
                }}>
                <Icon name="icon-info" width={16} height={16} fill="#47689f" />
              </Tooltip>
            }
          </div>
          <div className={styles.cell}>
            {item.cpu}
          </div>
          <div className={styles.cell}>
            {bytesToSize(item.ram)}
          </div>
          <div className={styles.cell}>
            {
              item.extras.requests > 0
                ? <div className={styles.upTo}><span>up to</span>{numeral(item.extras.requests, '0a')}</div>
                : '-'
            }
          </div>
          <div className={styles.cell}>
            <div className={styles.price}>
              <div><em>$</em>{p[0]}<span>.{p[1]}</span></div>
            </div>
          </div>
        </div>
      );
    });

    return results;
  }

  render() {
    const { currentApp } = this.props;

    const {
      currentSetup,
      originalSetup,
      billingPolicy,
      currentPlan,
      deploing,
      gearTypes,
      showSave,
    } = this.state;

    if (!Number.isInteger(currentPlan) || !gearTypes || !currentApp) return null;

    const priceText = new Decimal(originalSetup.price * originalSetup.min).toFixed(3).toString();
    const priceTextFooter = new Decimal(gearTypes[billingPolicy][currentPlan].price * currentSetup.min).toFixed(3).toString();

    const currentPlanFormatedText = (name) => {
      if (name === 'Development 1X') {
        return <Fragment><strong>{name}</strong> <span className={styles.starLila}>*</span></Fragment>;
      }

      return <strong>{name}</strong>;
    };

    return (
      <div>
        <BoxFieldset el="runntime__engines">
          <Notification note={this.state.note} close />

          <div className={[settingsStyles.settingsBox, styles.isDeploingHolder, deploing ? styles.isDeploing : ''].join(' ')}>
            <Field
              className="oneliner"
              label={<Label
                className="oneliner"
                text="Enable Horizontal Auto-Scaling"
                tooltipTextWidth={340}
                tooltipText="Improve your app's availability and dynamically autoscale resource capacity up or down within a secured and controlled range" />
              }
              input={<Toggle
                onChange={() => this.handleAutoscaling()}
                value={currentSetup.autoscaling} />
              } />

            <div className={settingsStyles.hr} />

            <Field
              className="oneliner"
              label={<Label
                className="oneliner"
                text="Enable High Availability"
                tooltipTextWidth={340}
                tooltipText="Increase app's fault tolerance with more engines, add smart load-balancing and smart monitoring." />
              }
              input={<Toggle
                onChange={() => this.handleHA()}
                value={currentSetup.highAvailability} />
              } />

            {
              currentSetup.highAvailability
                ?
                (
                  <div className={styles.haFeatures}>
                    <div><Icon width={14} height={14} name="icon-check" colored fill="#1bb933" />Redundancy</div>
                    <div><Icon width={14} height={14} name="icon-check" colored fill="#1bb933" />Zero-downtime Deployments</div>
                    <div><Icon width={14} height={14} name="icon-check" colored fill="#1bb933" />Smart Load-Balancing</div>
                    <div><Icon width={14} height={14} name="icon-check" colored fill="#1bb933" />Self Healing</div>
                  </div>
                )
                :
                (
                  <div className={styles.haFeatures}>
                    <div><Icon width={12} height={12} name="icon-close" colored fill="#ef3f61" />Redundancy</div>
                    <div><Icon width={12} height={12} name="icon-close" colored fill="#ef3f61" />Zero-Downtime Deployments</div>
                    <div><Icon width={12} height={12} name="icon-close" colored fill="#ef3f61" />Smart Load-Balancing</div>
                    <div><Icon width={12} height={12} name="icon-close" colored fill="#ef3f61" />Self Healing</div>
                  </div>
                )
            }


            <div className={settingsStyles.hr} />

            <ProgressPie
              autoscaling={currentSetup.autoscaling}
              currentSetup={currentSetup}
              name={gearTypes[billingPolicy][currentPlan].name}
              price={gearTypes[billingPolicy][currentPlan].price}
              onScale={this.onScale}
              engineScalingConfig={this.state.engineScalingConfig}
              scalingType={this.state.scalingType}
              currentApp={currentApp} />

            <div className={styles.type}>
              You're now using <strong>{originalSetup.min}</strong> engine{originalSetup.min > 1 ? 's' : ''} from {currentPlanFormatedText(originalSetup.name)} type for a total of <strong>${priceText}/h</strong> <span className={styles.starRed}>*</span><span className={styles.starBlue}>*</span>
              <br />

              <LinkWithBack
                className={stylesButton.tableButton}
                to={`/products/apps/${this.props.currentApp.slug}/metrics/engine`}>
                Usage Details
              </LinkWithBack>
            </div>

            <div className={settingsStyles.hr} />

            <div className={styles.verticalScalingTitle}>
              Select Vertical Scaling Type
              <Tooltip
                text={"Improve your app's performance by adding more computing power to your existing server/database"}
                tooltipStyles={{
                  color: '#fff',
                  fontFamily: 'Ubuntu',
                  fontSize: 14,
                  fontWeigt: 300,
                  borderRadius: 4,
                  maxWidth: 500,
                  width: 340,
                  unit: 4,
                  lightgrey: '#222933',
                  opaqueGrey: '#222933',
                }}>
                <Icon name="icon-info" width={16} height={16} fill="#47689f" />
              </Tooltip>
            </div>

            <div className={styles.table}>
              <div className={[styles.row, styles.header].join(' ')}>
                <div className={styles.cell}>
                  Type
                </div>
                <div className={styles.cell}>
                  mCPU
                  <Tooltip
                    text="mCPU is Micro Compute Unit, One mCPU = 40 millicores"
                    tooltipStyles={{
                      color: '#fff',
                      fontFamily: 'Ubuntu',
                      fontSize: 14,
                      fontWeigt: 300,
                      borderRadius: 4,
                      maxWidth: 500,
                      width: 340,
                      unit: 4,
                      lightgrey: '#222933',
                      opaqueGrey: '#222933',
                    }}>
                    <Icon name="icon-info" width={16} height={16} fill="#47689f" />
                  </Tooltip>
                </div>
                <div className={styles.cell}>
                  RAM
                </div>
                {
                  // <div className={styles.cell}>
                  //   Requests
                  // </div>
                }
                <div className={styles.cell}>
                  Bonus Requests <span className={styles.starGreen}>*</span>
                </div>
                <div className={styles.cell}>
                  Price /h <span className={styles.starRed}>*</span><span className={styles.starBlue}>*</span>
                </div>
              </div>

              {this.renderPlans(billingPolicy)}

            </div>
          </div>

          <div className={styles.legend}>
            <p><span className={styles.starRed}>*</span> Prices exclude VAT</p>
            <p>
              <span className={styles.starBlue}>*</span>
              SashiDo offers <a href="https://blog.sashido.io/power-up-with-sashidos-brand-new-engine-feature/#discountsandbonuses" target="blank">Sustained use Discounts</a>. These discounts are auto-applied at the end of each billing cycle based on sustained Engine resources usage per app.
            </p>
            <p>
              <span className={styles.starGreen}>*</span>
              <a href="https://blog.sashido.io/power-up-with-sashidos-brand-new-engine-feature/#discountsandbonuses" target="blank">Bonus requests</a> - free requests up to a fixed limit deducted from your monthly Extra consumption based on sustained Engine resources usage per app.
            </p>
            <p><span className={styles.starLila}>*</span>By default every SashiDo app includes <strong>one Development 1X</strong> engine free of charge.</p>
          </div>
        </BoxFieldset>

        <div className={[settingsStyles.customFooter, this.props.showFooter ? settingsStyles.ShowFooter : ''].join(' ')}>
          {
            deploing
            &&
            <div className={stylesLoader.message}>
              <div className={1 == 'ready' ? stylesLoader.green : null}>
                <span className={stylesLoader.loader}><span className={stylesLoader.loaderDots} />Your Application is Deploying.</span>
              </div>
            </div>

          }

          {
            showSave &&
            <div className={styles.footerMessage}>
              You've selected <strong>{currentSetup.min}</strong> engine{currentSetup.min > 1 ? 's' : ''} from {currentPlanFormatedText(gearTypes[billingPolicy][currentPlan].name)} type for a total of <strong>${priceTextFooter}/h</strong> <span className={styles.starRed}>*</span><span className={styles.starBlue}>*</span>
            </div>
          }

          {
            showSave &&
            <Button color="green" value="Save &amp; Deploy" progress={this.state.saving} onClick={this.handleSave} />
          }
        </div>
      </div>
    );
  }
}

export default Form;
